// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2AKznDjb3DfrwzVE7boQgH","dialog":"_2WK2DzQyuC-8Rd5zA1WWfb","content":"_39djQviCoiGvy1CR0YIdHb","closeBtn":"_3U63AHpSHan6_Mg98klFWj"};